import React from 'react';
import { useNewControllableValue } from '../../utils/use-controllable-value';
import { mergeProps } from '../../utils/with-default-props';
import { Column } from './column';
import { useColumns } from './use-columns';
import { withNativeProps } from '../../utils/native-props';
var classPrefix = "adm-picker-view";
var defaultProps = {
  defaultValue: []
};
export var PickerView = function PickerView(p) {
  var props = mergeProps(defaultProps, p);

  var _useNewControllableVa = useNewControllableValue(props),
      value = _useNewControllableVa[0],
      setValue = _useNewControllableVa[1];

  var columns = useColumns(props.columns, value);
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: "" + classPrefix
  }, columns.map(function (column, index) {
    return /*#__PURE__*/React.createElement(Column, {
      key: index,
      column: column,
      value: value[index],
      onSelect: function onSelect(val) {
        var nextValue = [].concat(value);
        nextValue[index] = val;
        setValue(nextValue);
      }
    });
  }), /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-mask " + classPrefix + "-mask-top"
  }), /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-mask " + classPrefix + "-mask-bottom"
  })));
};